// import { meaningOfLife } from "@strive/foo";

import UserMenu from "./UserManager";

export default UserMenu;
